module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAORJREFUOBGdUjsKwlAQXJOAvb0QsBCEdJaCJ/IypraRIDY2xgt4DGtPIYJxJu7jvXzeI2ZhssPOzJINEQlUVVUbImAJSwjfiLDLoyKYAR9F5rH5xwgWgKnC7+xRkEqBt0krT3uskkCcQJgDSwdb8AQwRX6F947+cPAUDHNgbO25IAKOIzYwE9WvCBID5z+W0BvXYfPAgN/jMmAJPe73MSuE58wGLJjZhMjvBjtZWOplDU97wcobs0LD077FFV/I5JrboU+Vux4dacP9JcD//wSkRiXXGbXSzDsd4gFYdwQdUKPH1b8IiH7ulNLRlQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/icons/atoms/star_icon_white/star_filled_small_turquese_centered@2x.png
// module id = 481
// module chunks = 0